// 百度统计 begin
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?ecb8057ae7acce1ba4949d2743f8615e";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
// 百度统计 end
/* jshint esversion: 6 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import APlayer from '@moefe/vue-aplayer';
import {
  Affix, Badge, Carousel, Checkbox, ConfigProvider, DatePicker, Dropdown, Icon, Input, InputNumber,
  Divider, Layout, Menu, message, Modal, Pagination, Popover, Radio, Select, Space, Steps, Tag, Timeline,Spin,Empty,Slider
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
// ConfigProvider 国际化-->中文引入
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import moment from 'moment';
// // 图片展示插件
// import Viewer from 'v-viewer';
// import 'viewerjs/dist/viewer.css';;
import VueClipboard from 'vue-clipboard2'

// 图可视化引擎
import G6 from '@antv/g6';
import Qs from 'qs';
// 全局参数和函数
import Base from './components/commonJs/base';
//全局设置 begin
// 用于和后台交互，发送请求
import axios from 'axios' 
Vue.prototype.$ajax = axios 
 
// 设置全局变量
import global_ from './Base.vue'
Vue.prototype.GLOBAL = global_;
axios.defaults.baseURL=global_.BASE_LOGIN_URL;
axios.defaults.baseIpInfo=global_.BASE_IP_INFO;//用户IP chenss 20220831
//全局设置 end

Vue.prototype.$Moment = moment;
Vue.prototype.$G6 = G6;
Vue.prototype.$qs = Qs;
Vue.prototype.$message = message;
Vue.prototype.$locale = zhCN;
Vue.prototype.$Swiper = Swiper;
Vue.use(Base, { store: store, _thisPro: Vue.prototype });
Vue.use(Divider);
Vue.use(Affix);
Vue.use(Badge);
Vue.use(Empty);
Vue.use(Carousel);
Vue.use(Checkbox);
Vue.use(ConfigProvider);
Vue.use(DatePicker);
Vue.use(Dropdown);
Vue.use(Icon);
Vue.use(Spin);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Modal);
Vue.use(Pagination);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(Select);
Vue.use(Space);
Vue.use(Steps);
Vue.use(Tag);
Vue.use(Slider);
Vue.use(Timeline);
// Vue.use(Viewer);
Vue.use(APlayer, {
  productionTip: true
});
// Vue.use(Share);
Vue.use(VueClipboard)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
